/**
 * If you are not familiar with React Navigation, check out the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
import { NavigationContainer, DefaultTheme, DarkTheme } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { ColorSchemeName, View } from 'react-native';
import { RootStackParamList } from '../../types';
import LinkingConfiguration from './LinkingConfiguration';
import Tenants from '../screens/tenants';
import Dashboard from '../screens/dashboard/Dashboard';
import LoginScreen from '../screens/login/login';
import RegisterScreen from '../screens/register/register';
import Home from '../screens/home';
import ForgotPasswordScreen from '../screens/forgotPassword/forgotPassword';
import ResetPasswordScreen from '../screens/resetPassword/resetPassword';
import Settings from '../screens/settings';
import MyAccount from '../screens/myAccount';
import ChangePassword from '../screens/changePassword';
import PropertyArchive from '../screens/propertyArchive';
import TenantArchive from '../screens/tenantArchive';
import ArchiveManager from '../screens/archiveManager';
import News from '../screens/news';
import Properties from '../screens/properties';
import PropertiesInfoDetails from '../screens/properties/PropertiesInfoDetails'
import PropertyAddress from '../screens/properties/propertyAddress';
import PropertySection from '../screens/properties/propertySection';
import Utilities from '../screens/properties/utilities';
import TenantScreen from '../screens/tenantsScreen';
import TenantReminder from '../screens/Reminder/AddReminder';
import PropertyDetails from '../screens/properties/propertyDetails';
import Certifications from '../screens/properties/certification';
import Licensing from '../screens/properties/licensing';
import Requirements from '../screens/properties/requirements';
import { navigate, navigationRef } from './RootNavigation';
import { useSelector } from 'react-redux';
import ajax, { httpUpload, setAuthHeaders } from '../../src/helpers/ajaxHelper';
import Loader from '../components/loader';
import payment from '../screens/payment';
import paymentDetails from '../screens/payment/paymentDetails';

import AddReminder from '../screens/Reminder/AddReminder';
import Reminder from '../screens/Reminder';
import AccountEdit from '../screens/settings/AccountEdit';
import PropertyDetailsReadOnly from '../screens/properties/propertyDetailsReadOnly';
import { WSnackBar } from './../vendor/react-native-smart-tip';
import TeanantDetails from '../screens/tenants/tenantOnboarding/screens/teanantDetails';
import PropertyDocumentation from '../screens/tenants/tenantOnboarding/screens/propertyDocumentation';
import RentalOffers from '../screens/tenants/tenantOnboarding/screens/rentalOffers';
import propertyInfo from '../screens/properties/propertyInfo';
import tenantInfo from '../screens/tenants/tenantInfo';
import TeanantOnboarding from '../screens/tenants/tenantOnboarding/screens/DashboardScreen';
import HoldingDeposit from '../screens/tenants/tenantOnboarding/screens/holdingDeposit';
import TenantIdentification from '../screens/tenants/tenantOnboarding/screens/TenantIdentification';
import TenancyInfoAndAgreement from '../screens/tenants/tenantOnboarding/screens/tenancyInfoAndAgreement';
import MovingIn from '../screens/tenants/tenantOnboarding/screens/movingIn';
import DepositProtectHomeSetup from '../screens/tenants/tenantOnboarding/screens/depositProtect_homeSetup';
import RentCollectionSignUp from '../screens/tenants/tenantOnboarding/screens/RentCollectionSignUp';
import MediaHub from '../screens/mediaHub';
import MediaHubDetails from '../screens/mediaHub/mediaHubDetails';
import DocumnetArchive from '../screens/documnetArchive';
import contactusScreen from '../screens/contactusScreen';
import aboutUs from '../screens/aboutUs';
import finance from '../screens/properties/finance';
import MyDocs from '../screens/MyDocs';
import Charity from '../screens/charity';
import legalScreen from '../screens/legalScreen';
import LandlordDetails from '../screens/properties/LandlordDetails';
import propertyTenantDetails from '../screens/tenants/tenantOnboarding/screens/propertyTenantDetails';
import { Hello } from '../screens/hello/hello';
import LandlordMediaDetails from '../screens/mediaHub/landlordDetails';
import MediaVideoDetails from '../screens/mediaHub/mediaVideoDetails';
import CommanBuyCertificate from '../screens/tenants/tenantOnboarding/screens/commanBuyCertificate/commonBuyCertificate';
import TeanantOffboarding from '../screens/tenants/tenantOffbaording/index'
import getPlatformType from '../helpers/helpers';
import Customise from '../screens/cookies/Customise';
import Cookies from '../screens/cookies/Cookies';
import store from '../redux/store';
import ProvidingNotice from '../screens/tenants/tenantOffbaording/offboardingScreen/ProvidingNotice';
import financeInsuranceQuote from '../screens/properties/financeInsuranceQuote';
import AddProperty from '../screens/tenants/tenantOnboarding/screens/addProoerty';
import CurrentOnboards from '../screens/tenants/tenantOnboarding/screens/currentOnboards';
import completedOnboards from '../screens/tenants/tenantOnboarding/screens/completedOnboards';
import archivedOnboards from '../screens/tenants/tenantOnboarding/screens/archivedOnboards';
import MyInvoices from '../screens/MyInvoices';
import BankAccount from '../screens/BankAccount';
import { showErrorToast } from '../screens/tenants/tenantOnboarding/helpers';
import renewalsFixedTerm from '../screens/tenants/tenantOnboarding/screens/renewalsFixedTerm';
import HubFlow from '../screens/HubFlow';
import registerDeposit from '../screens/tenants/tenantOnboarding/screens/registerDeposit';
import NewIssuePage from '../screens/maintenance/new-issues/NewIssuePage';
import new_issue_openflow_id from '../screens/maintenance/new-issues/new_issue_openflow_id';
import ActiveProject from '../screens/maintenance/active-projects/ActiveProject';
import active_project_openflow_id from '../screens/maintenance/active-projects/active_project_openflow_id';
import MaintenanceProject from '../screens/maintenance';
import Maintenance from '../screens/tenants/tenantOnboarding/screens/Maintenance';
import MarketplaceWidget from '../screens/marketplace/MarketplaceWidget';


export default function Navigation({ colorScheme }: { colorScheme: ColorSchemeName }) {
  const routeNameRef = React.useRef();
  const layoutType = getPlatformType();
  const isToken = useSelector((state) => state?.AppReducer?.token);


  setAuthHeaders(isToken);
  const [cookiesPopupVisible, setCookiesPopupVisible] = useState(false);
  const show_customise = useSelector((state) => state?.cookiesReducer?.show_banner_customise);
  const show_cookies = useSelector((state) => state?.cookiesReducer?.show_banner_cookies);


  const isEmbedded = typeof window !== 'undefined' && window.self !== window.top;

  useEffect(() => {
    if (isEmbedded) return;
    const cookiesBanner = localStorage.getItem('cookies_status');
    if (cookiesBanner) {
      setCookiesPopupVisible(false);
    } else {
      setTimeout(() => {
        setCookiesPopupVisible(true);
      }, 4000);
    }
  }, [isEmbedded]);
  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      backBehavior="history"
      ref={navigationRef}
      onReady={() => (routeNameRef.current = navigationRef.current.getCurrentRoute().name)}
      theme={colorScheme === 'dark' ? DarkTheme : DefaultTheme}
      onStateChange={() => {

        const currentRouteName = navigationRef.current.getCurrentRoute().name;
        routeNameRef.current = currentRouteName;
      }}
    >
      <>
        <RootNavigator />
        {show_customise ?
          <View
            style={{
              width: '100%',
              marginTop: layoutType == 'phone' ? '18%' : '7%',
              position: 'absolute',
            }}
          >
            <Customise />
          </View>
          : null}
        {cookiesPopupVisible && show_cookies && !isEmbedded && (

          <View
            style={{
              width: '100%',
              paddingTop: layoutType == 'phone' ? '18%' : '7%',
              position: 'absolute',
              height: '100%',
            }}
          >
            <Cookies
              setCookiesPopupVisible={setCookiesPopupVisible}
              cookiesPopupVisible={cookiesPopupVisible}
            />
          </View>
        )}
      </>
    </NavigationContainer>
  );
}

// A root stack navigator is often used for displaying modals on top of all other content
// Read more here: https://reactnavigation.org/docs/modal
const Stack = createStackNavigator<RootStackParamList>();

function RootNavigator() {
  const isToken = useSelector((state) => state?.AppReducer?.token);
  const [isLoading, setIsLoading] = useState(false);
  const tenantLoading = useSelector((state) => state?.tenant?.tenantLoading);
  const flowInfoLoading = useSelector((state) => state?.tenant?.flowInfoLoading);
  const contractGenerating = useSelector((state) => state?.tenant?.contractGenerating);
  const sendContractLoading = useSelector((state) => state?.tenant?.sendContractLoading);
  const rentalOfferSaving = useSelector((state) => state?.tenant?.rentalOfferSaving);
  const is_renewed = useSelector((state) => state?.tenant?.flowIdInfo?.is_renewed);
  const setTokenInheader = async () => {
    await setAuthHeaders(isToken);
  }
  useEffect(() => {
    setTokenInheader()
  }, [isToken]);
  ajax.interceptors.request.use(
    function (config) {
      // spinning start to show

      // console.log('api requested', config);
      setIsLoading(true);
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  ajax.interceptors.response.use(
    function (response) {
      // console.log('api response hitesh', response);
      // spinning hide
      setIsLoading(false);
      if (response?.data?.message) {
        if (response?.data?.status) {
          showSuccesToast(response.data.message);
        } else {
          showErrorToast(response.data.message);
        }
      }
      return response;
    },

    function (error) {
      setIsLoading(false);
      const status = error?.response?.status;
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Something went wrong!';

      if (status === 401 || status === 403) {
        navigate("login");
      } else {
        showErrorToast(errorMessage);
      }

      return Promise.reject(error);
    }
  );
  httpUpload.interceptors.request.use(
    function (config) {
      // spinning start to show
      // console.log('api requested', config);
      setIsLoading(true);
      return config;
    },
    function (error) {
      setIsLoading(false);
      return Promise.reject(error);
    }
  );

  httpUpload.interceptors.response.use(
    function (response) {
      // spinning hide
      console.log('api response', response);
      setIsLoading(false);
      return response;
    },
    function (error) {
      setIsLoading(false);
      // alert('Server Error');
      return Promise.reject(error);
    }
  );
  return (
    <>
      <Stack.Navigator
        initialRouteName={isToken ? 'home' : 'Hello'}
        screenOptions={{ headerShown: false }}
        backBehavior="history"
      >
        <Stack.Screen name="HubFlow" component={HubFlow} />
        <Stack.Screen name="RegisterDeposit" component={registerDeposit} />
        <Stack.Screen name="home" component={Home} />
        <Stack.Screen name="Hello" component={Hello} />
        <Stack.Screen name="AccountEdit" component={AccountEdit} />
        <Stack.Screen name="Tenants" component={Tenants} />
        <Stack.Screen name="TeanantInfo" component={tenantInfo} />
        <Stack.Screen name="TeanantOnboarding" component={TeanantOnboarding} />
        <Stack.Screen name="Utilities" component={Utilities} />
        <Stack.Screen name="PropertiesInfoDetails" component={PropertiesInfoDetails} />
        <Stack.Screen name="Reminder" component={Reminder} />

        <Stack.Screen name="AddReminder" component={AddReminder} />
        <Stack.Screen name="EditReminder" component={AddReminder} />
        <Stack.Screen name="login" component={LoginScreen} />

        <Stack.Screen name="Payments" component={payment} />
        <Stack.Screen name="PaymentDetails" component={paymentDetails} />
        <Stack.Screen name="PaymentIncomingDetails" component={paymentDetails} />
        <Stack.Screen name="PaymentOutgoingDetails" component={paymentDetails} />
        <Stack.Screen name="PaymentNewProperty" component={paymentDetails} />

        <Stack.Screen name="RegisterScreen" component={RegisterScreen} />
        <Stack.Screen name="ForgotPasswordScreen" component={ForgotPasswordScreen} />
        <Stack.Screen name="ResetPasswordScreen" component={ResetPasswordScreen} />
        <Stack.Screen name="News" component={News} />
        <Stack.Screen name="Root" component={Dashboard} />
        <Stack.Screen name="Setting" component={Settings} />
        <Stack.Screen name="ChangePassword" component={ChangePassword} />
        <Stack.Screen name="ArchiveManager" component={ArchiveManager} />
        <Stack.Screen name="TenantArchive" component={ArchiveManager} />
        <Stack.Screen name="PropertyArchive" component={ArchiveManager} />
        <Stack.Screen name="DocumentArchive" component={ArchiveManager} />
        <Stack.Screen name="MyAccount" component={AccountEdit} />
        {/* <Stack.Screen name="tenants" component={Tenants} /> */}
        <Stack.Screen name="TenantDeposit" component={TenantScreen} />

        <Stack.Screen name="PropertyDetails" component={PropertyDetails} />
        <Stack.Screen name="PropertyInfo" component={propertyInfo} />
        <Stack.Screen name="PropertySection" component={PropertySection} />
        <Stack.Screen name="PropertyAddress" component={PropertyAddress} />
        <Stack.Screen name="Properties" component={Properties} />
        <Stack.Screen name="Certification" component={Certifications} />
        <Stack.Screen name="Licensing" component={Licensing} />
        <Stack.Screen name="Requirements" component={Requirements} />
        <Stack.Screen name="PropertyDetailsMore" component={PropertyDetailsReadOnly} />
        <Stack.Screen name="PropertyDocumentation" component={PropertyDocumentation} />
        <Stack.Screen name="TenantDetails" component={TeanantDetails} />
        <Stack.Screen name="PropertyTenantDetails" component={propertyTenantDetails} />
        <Stack.Screen name="RentalOffers" component={RentalOffers} />
        <Stack.Screen name="HoldingDeposit" component={HoldingDeposit} />
        <Stack.Screen name="IdAndReference" component={TenantIdentification} />
        <Stack.Screen name="TenancyAgreement" component={TenancyInfoAndAgreement} />
        <Stack.Screen name="MoveIn" component={MovingIn} />
        <Stack.Screen name="DepositProtectHomeSetup" component={DepositProtectHomeSetup} />
        <Stack.Screen name="Maintenance" component={Maintenance} />
        <Stack.Screen name="ContactUs" component={contactusScreen} />
        <Stack.Screen name="MediaHub" component={MediaHub} />
        <Stack.Screen name="MediaHub Details" component={MediaHubDetails} />
        <Stack.Screen name="MyInvoices" component={MyInvoices} />
        <Stack.Screen name="BankAccount" component={BankAccount} />
        <Stack.Screen name="RentCollectionSignUp" component={RentCollectionSignUp} />
        <Stack.Screen name="AboutUs" component={aboutUs} />
        <Stack.Screen name="financeDetails" component={finance} />
        <Stack.Screen name="MyDocs" component={MyDocs} />
        <Stack.Screen name="LegalBits" component={legalScreen} />
        <Stack.Screen name="Charity" component={Charity} />
        <Stack.Screen name="LandlordDetails" component={LandlordDetails} />
        <Stack.Screen name="LandlordMediaDetails" component={LandlordMediaDetails} />
        <Stack.Screen name="MediaVideoDetails" component={MediaVideoDetails} />
        <Stack.Screen name="CommonBuyCertificate" component={CommanBuyCertificate} />
        <Stack.Screen name="TeanantOffboarding" component={TeanantOffboarding} />
        <Stack.Screen name="Notice" component={ProvidingNotice} />
        <Stack.Screen name="financeInsuranceQuote" component={financeInsuranceQuote} />
        <Stack.Screen name="addproperty" component={AddProperty} />
        <Stack.Screen name="CurrentOnboards" component={CurrentOnboards} />
        <Stack.Screen name="CompletedOnboards" component={completedOnboards} />
        <Stack.Screen name="ArchivedOnboards" component={archivedOnboards} />
        <Stack.Screen name="RenewalsFixedTerm" component={renewalsFixedTerm} />
        <Stack.Screen name="MaintenanceProject" component={MaintenanceProject} />
        <Stack.Screen name="NewIssues" component={NewIssuePage} />
        <Stack.Screen name="New_issues" component={new_issue_openflow_id} />
        <Stack.Screen name="ActiveProject" component={ActiveProject} />
        <Stack.Screen name="CompletedProject" component={ActiveProject} />
        <Stack.Screen name="ActiveProjects" component={active_project_openflow_id} />
        <Stack.Screen name="CompletedProjects" component={active_project_openflow_id} />

        <Stack.Screen name="ArchivedProject" component={ActiveProject} />
        <Stack.Screen name="ArchivedProjects" component={active_project_openflow_id} />
        <Stack.Screen name="HubitaEmbedX" component={MarketplaceWidget} />
      </Stack.Navigator>
      <Loader
        loading={tenantLoading || flowInfoLoading || isLoading || contractGenerating || sendContractLoading || rentalOfferSaving}
        isContractGenerating={contractGenerating}
        isContractSending={sendContractLoading}
        isRentalOfferSaving={rentalOfferSaving}
        isRenewed={is_renewed}
      />
    </>
  );
}
